module.exports = __webpack_public_path__ + "images/169828d19a2ac5b6dc6b9d34e1a4ad6c-Rocky_Mountaineer_Logo_Horizontal_Gold.jpg";